import api from '../token';

export const ListBanco = async () => {
  try {
    const response = await api.post('/getBanco');
    return response.data;
  } catch (error) {
    
    return [];
  }
};

